import { NB } from '@cerebral-inc/ui';

export interface AssessmentButtonProps {
  onSubmit: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  marginTop?: string;
  text: string;
  variant?: string;
  isStickyButton?: boolean;
  display?: object;
}

const { Button, Center, useMediaQuery } = NB;

export const AssessmentButton = ({
  onSubmit,
  isLoading,
  isDisabled,
  marginTop,
  text,
  display,
  variant = 'primary',
  isStickyButton = false
}: AssessmentButtonProps) => {
  const [isMobile] = useMediaQuery({ minWidth: 0, maxWidth: 768 });
  const isStickyButtonOnMobile = isMobile && isStickyButton;

  const generateButton = () => {
    return (
      <Button
        variant={variant}
        onPress={onSubmit}
        isDisabled={isDisabled || isLoading}
        isLoading={isLoading}
        w={{ base: '100%', sm: '320px' }}
        maxW="100%"
        h="56px"
        _text={{
          fontFamily: 'Poppins',
          fontSize: '14px',
          fontWeight: 600
        }}
        _disabled={{
          opacity: 1
        }}
        id="onboardingButton"
      >
        {text}
      </Button>
    );
  };

  return isStickyButtonOnMobile ? (
    <Center
      display={display}
      position="sticky"
      bottom={0}
      w="100vw"
      px="24px"
      py="16px"
      backgroundColor="c_white.900"
      borderTopColor="#d9d9d9"
      borderTopStyle="solid"
      borderTopWidth="1px"
    >
      {generateButton()}
    </Center>
  ) : (
    <Center w="100%" mt={marginTop} display={display}>
      {generateButton()}
    </Center>
  );
};
